import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { AuthProvider } from "@/context/AuthContext";
import PublicLayout from "@/components/public/PublicLayout";
import ProtectedRoute from "@/components/admin/ProtectedRoute";

import Home from "@/pages/public/Home";
import ServicesOverview from "@/pages/public/ServicesOverview";
import ServiceDetail from "@/pages/public/ServiceDetail";
import Gallery from "@/pages/public/Gallery";
import ProjectDetail from "@/pages/public/ProjectDetail";
import About from "@/pages/public/About";
import ServiceAreas from "@/pages/public/ServiceAreas";
import PropertyStrata from "@/pages/public/PropertyStrata";
import Contact from "@/pages/public/Contact";

import Login from "@/pages/admin/Login";
import AuthCallback from "@/pages/admin/AuthCallback";
import Dashboard from "@/pages/admin/Dashboard";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/command" element={<Login />} />
      <Route path="/command/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />

      <Route element={<PublicLayout />}>
        <Route path="/" element={<Home />} />
        <Route path="/services" element={<ServicesOverview />} />
        <Route path="/services/:slug" element={<ServiceDetail />} />
        <Route path="/our-work" element={<Gallery />} />
        <Route path="/our-work/:slug" element={<ProjectDetail />} />
        <Route path="/about" element={<About />} />
        <Route path="/service-areas" element={<ServiceAreas />} />
        <Route path="/property-strata-managers" element={<PropertyStrata />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="*" element={<Home />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <HelmetProvider>
      <AuthProvider>
        <BrowserRouter>
          <AppRouter />
        </BrowserRouter>
      </AuthProvider>
    </HelmetProvider>
  );
}

export default App;
